/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_ModeInputs */

const en_cook_mode = /** @type {(inputs: Cook_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cooking mode`)
};

const de_cook_mode = /** @type {(inputs: Cook_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochmodus`)
};

/**
* | output |
* | --- |
* | "Cooking mode" |
*
* @param {Cook_ModeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_mode = /** @type {((inputs?: Cook_ModeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_ModeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_mode(inputs)
	return en_cook_mode(inputs)
});